module.exports = __webpack_public_path__ + "img/hr-red-croton-00.bc7ae717.png";